import { PropsWithRef } from 'react';
import { DatepickerProps } from './types';
import { Datepicker as JuicyDatepicker, FormGroup } from '@vtbhome/juicyfront';
import { Typography } from '../typography/typography';
import { ErrorMessageInput } from '../error-message-input/error-message-input';

export const Datepicker = ({ label, error, hint, ...props }: PropsWithRef<DatepickerProps>) => {
    return (
        <FormGroup
            label={
                <Typography size='body2_short' color='neutral_50'>
                    {label}
                </Typography>
            }
            errorMessage={<ErrorMessageInput error={error} hint={hint} />}>
            <JuicyDatepicker {...props} />
        </FormGroup>
    );
};

Datepicker.displayName = 'Datepicker';
